class DropHint {
  constructor(ownerSlot, config) {
    /** 块的样式，可覆盖 */
    this.hintClassName = '';
    this.ownerSlot = ownerSlot;
    this.designer = this.ownerSlot.designer;
    this.renderer = this.ownerSlot.renderer;
    this.config = config;
    this.uc = this.designer.uc;
  }
  get editZoneState() {
    return this.designer.editZoneState;
  }
  /** 获取这个放置点相关的组件是哪个，用于高亮展示，可返回 null 表示没有和这个放置点相关的组件 */
  getRelatedCompPath() {
    return null;
  }
  getAreaSize() {
    const rect = this.getRect();
    if (!rect) return Infinity;
    const {
      width,
      height
    } = rect;
    return width * height;
  }
}
export default DropHint;
//# sourceMappingURL=base.js.map
